import React from 'react';
import type { EntityType } from '../types';
import type { EventLogEntry, ParserEventLogEntry } from '@mariana/labos-client';
import { formatDate } from '../utils/formatDate';
import { EventsTable } from './EventsTable';
import './EntityDetail.css';

interface EventsTabProps {
  entityType: EntityType;
  events: EventLogEntry[];
  parserEvents: ParserEventLogEntry[];
}

export const EntityDetailEventsTab: React.FC<EventsTabProps> = ({
  entityType,
  events,
  parserEvents,
}) => {
  return (
    <>
      {events.length === 0 ? (
        <div className="events-empty-state">No events recorded for this {entityType}.</div>
      ) : (
        <EventsTable events={events} showEntityColumns={false} />
      )}

      {entityType === 'test' && (
        <div className="entity-detail-section">
          <h3>Parser Uploads</h3>
          {parserEvents.length > 0 ? (
            <table className="entity-events-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Timestamp</th>
                  <th>Parser</th>
                  <th>File Name</th>
                  <th>Status</th>
                  <th>Duration (ms)</th>
                </tr>
              </thead>
              <tbody>
                {parserEvents.map((pe) => (
                  <tr key={pe.id}>
                    <td>{pe.id}</td>
                    <td>{formatDate(pe.createdAt)}</td>
                    <td>{pe.parserName}</td>
                    <td>{pe.fileName}</td>
                    <td>
                      <span className={`action-badge ${pe.status === 'success' ? 'created' : pe.status === 'error' ? 'deleted' : 'updated'}`}>
                        {pe.status}
                      </span>
                    </td>
                    <td>{pe.durationMs ?? '-'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="events-empty-state">No parser uploads found for this entity.</div>
          )}
        </div>
      )}
    </>
  );
};
